/* Desayunos del Cielo · home v2 behaviours (tabs, reviews carousel, reels coverflow). No audio anywhere. */
(() => {
  if (window.ddcHomeInit) return;
  window.ddcHomeInit = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Tabs: ¡Los más vendidos! ---------- */
  function initTabs(root) {
    const list = root.querySelector('[data-ddc-tabs]');
    if (!list || list.dataset.ready) return;
    list.dataset.ready = '1';
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    const panels = tabs.map((t) => document.getElementById(t.getAttribute('aria-controls')));
    list.hidden = false;
    root.classList.add('is-tabbed');

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (panels[i]) panels[i].hidden = !on;
      });
      if (focus) tabs[index].focus();
      tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i, false));
      tab.addEventListener('keydown', (e) => {
        let next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          e.preventDefault();
          select(next, true);
        }
      });
    });
    select(0, false);
  }

  /* ---------- Google reviews carousel + "Leer más" ---------- */
  function initReviews(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('[data-ddc-review-more]').forEach((btn) => {
      const text = btn.parentElement.querySelector('[data-ddc-review-text]');
      if (!text) return;
      btn.hidden = false;
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        text.classList.toggle('is-clamped', open);
        btn.textContent = open ? 'Leer más' : 'Leer menos';
      });
    });

    const track = root.querySelector('[data-ddc-reviews-track]');
    const nav = root.querySelector('[data-ddc-reviews-nav]');
    if (!track || !nav) return;
    const prev = nav.querySelector('[data-ddc-prev]');
    const next = nav.querySelector('[data-ddc-next]');
    const step = () => {
      const item = track.querySelector('li');
      return item ? item.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      nav.hidden = max <= 0;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Instagram reels coverflow ---------- */
  function initReels(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('[data-ddc-reels-track]');
    const items = Array.from(root.querySelectorAll('[data-ddc-reel]'));
    if (!track || !items.length) return;
    const prev = root.querySelector('[data-ddc-prev]');
    const next = root.querySelector('[data-ddc-next]');
    let current = -1;

    const videoOf = (item) => item.querySelector('video');
    /* Posters load only when the reels section approaches the viewport. */
    const hydratePosters = () => {
      items.forEach((item) => {
        const v = videoOf(item);
        if (v && v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
      });
    };
    if ('IntersectionObserver' in window) {
      const posterIO = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { hydratePosters(); posterIO.disconnect(); }
      }, { rootMargin: '600px 0px' });
      posterIO.observe(root);
    } else {
      hydratePosters();
    }
    const load = (video) => {
      if (video && !video.src && video.dataset.src) {
        video.src = video.dataset.src;
        video.muted = true;
        video.load();
      }
    };
    const updatePlayButton = (item, playing) => {
      const button = item.querySelector('[data-ddc-play]');
      if (!button) return;
      button.setAttribute('aria-label', playing ? 'Pausar video' : 'Reproducir video');
      button.querySelector('[data-ddc-play-icon]').hidden = playing;
      button.querySelector('[data-ddc-pause-icon]').hidden = !playing;
      button.classList.toggle('is-playing', playing);
    };
    const pauseInactive = () => {
      items.forEach((item, i) => {
        const v = videoOf(item);
        if (!v) return;
        if (i !== current && !v.paused) {
          v.pause();
          updatePlayButton(item, false);
        }
      });
    };
    const setCurrent = (i) => {
      if (i === current) return;
      current = i;
      items.forEach((item, k) => {
        const d = k - i;
        item.classList.toggle('is-center', d === 0);
        item.classList.toggle('is-left', d < 0);
        item.classList.toggle('is-right', d > 0);
        item.style.setProperty('--d', String(Math.min(Math.abs(d), 3)));
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= items.length - 1;
      pauseInactive();
      if (autoCenter && inView) playCenter();
    };
    const autoCenter = root.hasAttribute('data-ddc-autoplay-center') && !reduceMotion;
    let inView = false;
    const playCenter = () => {
      const item = items[current];
      const v = item && videoOf(item);
      if (!v) return;
      load(v);
      v.muted = true;
      v.play().then(() => updatePlayButton(item, true)).catch(() => updatePlayButton(item, false));
    };
    const centerIndex = () => {
      const mid = track.getBoundingClientRect().left + track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      items.forEach((item, i) => {
        const r = item.getBoundingClientRect();
        const dist = Math.abs(r.left + r.width / 2 - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    };
    const goTo = (i) => {
      const item = items[Math.max(0, Math.min(items.length - 1, i))];
      const left = item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2;
      track.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
    };

    if (prev) {
      prev.hidden = false;
      prev.addEventListener('click', () => goTo(current - 1));
    }
    if (next) {
      next.hidden = false;
      next.addEventListener('click', () => goTo(current + 1));
    }
    items.forEach((item, i) => {
      item.addEventListener('click', (e) => {
        if (i !== current && !e.target.closest('a')) {
          e.preventDefault();
          goTo(i);
        }
      });
      const play = item.querySelector('[data-ddc-play]');
      if (play) {
        play.addEventListener('click', () => {
          const v = videoOf(item);
          if (i !== current) {
            goTo(i);
            return;
          }
          load(v);
          v.muted = true;
          v.controls = false;
          if (v.paused) {
            v.play().then(() => updatePlayButton(item, true)).catch(() => updatePlayButton(item, false));
          } else {
            v.pause();
            updatePlayButton(item, false);
          }
        });
      }
    });

    let t;
    track.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(t);
        t = window.setTimeout(() => setCurrent(centerIndex()), 90);
      },
      { passive: true }
    );

    root.classList.add('is-ready');
    const startIndex = Math.floor((items.length - 1) / 2); // empieza en el centro: sin espacio en blanco a la izquierda
    window.requestAnimationFrame(() => {
      const item = items[startIndex];
      track.scrollLeft = item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2;
      setCurrent(centerIndex());
    });

    if (autoCenter && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          inView = e.isIntersecting && e.intersectionRatio >= 0.5;
          if (inView) playCenter();
          else items.forEach((item) => { const v = videoOf(item); if (v && !v.paused) { v.pause(); updatePlayButton(item, false); } });
        });
      }, { threshold: [0, 0.5] }).observe(track);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        items.forEach((item) => {
          const video = videoOf(item);
          if (video) video.pause();
          updatePlayButton(item, false);
        });
      }
    });
  }

  function init(scope) {
    const s = scope || document;
    s.querySelectorAll('.ddc-best').forEach(initTabs);
    s.querySelectorAll('[data-ddc-reviews]').forEach(initReviews);
    s.querySelectorAll('[data-ddc-reels]').forEach(initReels);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
